<panel width="900">
  <h1>{{ 'settlements-list.header' | translate }}</h1>
  @if (!settlements) {
    <skeletons [defaultSkeletons]="5" />
  }
  @if (settlements) {
    <section>
      <custom-input label="{{ 'settlement.show-inactive' | translate }}" [inputType]="inputTypeEnum.Switch" [(value)]="showInactiveSettlements" />
    </section>
  }
  @if (settlements) {
    <list-view scrollable>
      <header defaultSort="ascending">{{ 'settlements-list.column.settlement-number' | translate }}</header>
      <header defaultSort="ascending">{{ 'general.column.company-name' | translate }}</header>
      <header>{{ 'settlements-list.column.created-date' | translate }}</header>
      <header>{{ 'settlements-list.column.installments' | translate }}</header>
      <header align-right>{{ 'settlements-list.column.payment-sum' | translate }}</header>
      <header align-right>{{ 'settlements-list.column.settlement-amount' | translate }}</header>
      <row *listData="let settlement from settlements"
        [hidden]="(!showInactiveSettlements && !settlement.isActive)"
        (action)="selectSettlement(settlement);"
        [statusColor]="getStatusColor(settlement)"
        [statusTitle]="getStatusTitle(settlement) | translate"
        [brand]="settlement.settlementProductPlans[0]?.productPlan?.brandId"
        [select]="selectedSettlement == settlement">
        <column>{{ settlement.referenceNumber }}</column>
        <column>{{ settlement.company.name }}</column>
        <column [sortValue]="settlement.created">{{ settlement.created | customDate: 'shortDate' }}</column>
        <column>{{ settlement.installments }}</column>
        <column [sortValue]="settlement.payementSumInclVat" align-right>{{ settlement.paymentSumInclVat | currency }}</column>
        <column [sortValue]="settlement.settlementSum" align-right>{{ settlement.settlementSum | currency }}</column>
      </row>
    </list-view>
  }
</panel>

@if (selectedSettlement) {
  <panel width="650">
    <h1>{{ 'settlement.header' | translate }} {{ selectedSettlement.referenceNumber }}</h1>
    <scrollable>
      <settlement-status [settlement]="selectedSettlement" />
      @if (selectedSettlement.status === settlementStatus.Sent && !selectedSettlement.acceptedByClient) {
        <section>
          @if (loading) {
            <skeleton height="38px" />
          }
          @if (!loading) {
            <button #reminderButton (click)="sendReminder(selectedSettlement.id!)" [active]="!reminderSent" [labelSaved]="'settlements-list.button.reminder-sent' | translate" [label]="'settlements-list.button.send-email-reminder-to-accept' | translate"></button>
            <button #acceptButton (click)="acceptSettlement()">{{ 'settlement.register-accepted' | translate }}</button>
          }
        </section>
      }
      <settlement [settlement]="selectedSettlement" [plansAmount]="plansAmount" />
      @if (selectedSettlement.status != settlementStatus.Unconfirmed) {
        @if (selectedSettlement.dateSentToClient) {
          <h2>{{ 'settlement.download-pdf' | translate }}</h2>
        }
        @if (selectedSettlement.dateSentToClient) {
          <section align-right><icon type="download" (click)="downloadFile(selectedSettlement)">{{ 'settlement.download-pdf-link' | translate }}</icon></section>
        }
        <h2>{{ 'settlement.payments-for-settlement' | translate }}</h2>
        @if (selectedSettlement.status == settlementStatus.Sent && !selectedSettlement.isFullyPaid) {
          <section three-columns>
            <custom-input label="{{ 'settlement.payments.amount' | translate }}" placeholder="{{ 'settlement.payments.amount-placeholder' | translate }}" [inputType]="inputTypeEnum.Currency" [(value)]="newPaymentAmount" />
            <date-input label="{{ 'settlement.payments.created' | translate }}" [(value)]="newPaymentDate" />
            <button #paymentButton type="confirm" [ignoreValidation]="true" [active]="newPaymentAmount > 0" (click)="createPayment()">
              <icon type="hand-holding-dollar" />
              {{ 'settlement.payments.create-payment' | translate }}
            </button>
          </section>
        }
        <list-view [selectable]="false">
          <header [sortColumn]="false" defaultSort="ascending">{{ 'settlement.payment-column-header.created-date' | translate }}</header>
          <header [sortColumn]="false" align-right>{{ 'settlement.payment-column-header.amount-incl-vat' | translate }}</header>
          <row *listData="let payment from selectedSettlement.settlementPayments" [clickable]="false">
            <column [sortValue]="payment.created">{{ payment.created | customDate: 'shortDate' }}</column>
            <column align-right>{{ payment.amount | currency }}</column>
          </row>
        </list-view>
        <section one-column class="align-right">
          <div>
            <h2>{{ 'settlement.settlement-payments.total-amount-paid-incl-vat' | translate: { total: selectedSettlement.paymentSumInclVat | currency } }}</h2>
            <div>{{ 'settlement.settlement-payments.total-amount-remains-incl-vat' | translate: { total: selectedSettlement.amountRemainingInclVat | currency } }}</div>
            <small>{{ 'settlement.amounts-include-vat-info' | translate}}</small>
          </div>
        </section>
      }
      @if (!loading) {
        <section>
          @if (selectedSettlement.status != settlementStatus.Completed && selectedSettlement.status != settlementStatus.Cancelled) {
            <button type="reject" (click)="cancelSettlement()">{{ 'settlement-list.button.cancel' | translate }}</button>
          }
          <ng-container *requiredCredential="approveSettlementCredential">
            @if (selectedSettlement.status == settlementStatus.Unconfirmed) {
              <button #approvebutton type="confirm" (click)="approveSettlement(selectedSettlement);">{{ 'settlements-list.button.approve' | translate }}</button>
            }
            @if (selectedSettlement.status == settlementStatus.Sent) {
              <button type="confirm" [active]="selectedSettlement.isFullyPaid" (click)="closeSettlement()">{{ 'settlement-list.button.close' | translate }}</button>
            }
          </ng-container>
        </section>
      }
      @if (loading) {
        <skeletons [defaultSkeletons]="2" />
      }
    </scrollable>
  </panel>
}

@if (selectedSettlement && communicationLog != undefined && communicationLog.length > 0) {
  <panel width="600">
    <scrollable>
      <communication-log [communicationLog]="communicationLog" />
    </scrollable>
  </panel>
}
